function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "#6B207D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.82,1h-.75V.33A.35.35,0,0,0,12.69,0a.36.36,0,0,0-.33.33V1H10.7V.33a.35.35,0,0,0-.7,0V1H8.34V.33A.35.35,0,0,0,8,0a.35.35,0,0,0-.32.33V1H6V.33A.35.35,0,0,0,5.59,0a.36.36,0,0,0-.32.32V1H3.61V.33A.35.35,0,0,0,3.23,0a.35.35,0,0,0-.32.33V1H2.16A2.16,2.16,0,0,0,0,3.17V13.84A2.16,2.16,0,0,0,2.16,16H13.82A2.15,2.15,0,0,0,16,13.84V3.17A2.15,2.15,0,0,0,13.82,1Zm1.45,12.83a1.45,1.45,0,0,1-1.45,1.45H2.15A1.45,1.45,0,0,1,.7,13.84V3.17A1.45,1.45,0,0,1,2.15,1.71H2.9v.75a.35.35,0,0,0,.38.33.35.35,0,0,0,.33-.33V1.71H5.27v.75a.34.34,0,0,0,.38.33A.36.36,0,0,0,6,2.46V1.71H7.64v.75A.34.34,0,0,0,8,2.79a.35.35,0,0,0,.33-.33V1.71H10v.75a.35.35,0,0,0,.7,0V1.71h1.66v.75a.36.36,0,0,0,.38.33.35.35,0,0,0,.33-.33V1.71h.75a1.45,1.45,0,0,1,1.45,1.46Z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.92,5.43H2.05a.36.36,0,0,0-.33.38.36.36,0,0,0,.33.32H13.92a.35.35,0,0,0,0-.7Z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92,7.16H2.13a.35.35,0,0,0-.35.35h0V9.93a.35.35,0,0,0,.35.35H4.92a.35.35,0,0,0,.35-.35h0V7.51a.35.35,0,0,0-.35-.35ZM4.57,9.57H2.49V7.86H4.57Z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92,11H2.13a.36.36,0,0,0-.35.36v2.4a.36.36,0,0,0,.35.36H4.92a.35.35,0,0,0,.35-.35h0v-2.4A.36.36,0,0,0,4.92,11Zm-.35,2.41H2.49v-1.7H4.57Z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38,7.16H6.59a.35.35,0,0,0-.35.35h0V9.93a.35.35,0,0,0,.35.35H9.38a.35.35,0,0,0,.35-.35h0V7.51a.35.35,0,0,0-.35-.35ZM9,9.57H7V7.86H9Z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.84,7.16H11.05a.35.35,0,0,0-.35.35h0V9.93a.35.35,0,0,0,.35.35h2.79a.35.35,0,0,0,.35-.35h0V7.51a.35.35,0,0,0-.35-.35Zm-.35,2.41H11.41V7.86h2.08Z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38,11H6.59a.36.36,0,0,0-.35.36v2.4a.36.36,0,0,0,.35.36H9.38a.35.35,0,0,0,.35-.35h0v-2.4A.35.35,0,0,0,9.38,11ZM9,13.41H7v-1.7H9Z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.84,11H11.05a.36.36,0,0,0-.35.36v2.4a.36.36,0,0,0,.35.36h2.79a.35.35,0,0,0,.35-.35h0v-2.4A.35.35,0,0,0,13.84,11Zm-.35,2.41H11.41v-1.7h2.08Z",
    style: {
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCalendar);
export default __webpack_public_path__ + "static/media/daily_calendar.dbe78dc5.svg";
export { ForwardRef as ReactComponent };